var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-dropdown-menu',{class:[true?'width'+_vm.option.width:'',_vm.option.isright?'isright':''],attrs:{"direction":_vm.option.direction}},[_c('van-dropdown-item',{attrs:{"title":_vm.option.name,"options":_vm.option.item},on:{"change":_vm.change}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56c63696","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myMoreBtn.vue
// module id = 217
// module chunks = 0